import { IconNames } from "@/types/v2";
import {
  AppWindowIcon,
  AppWindowMacIcon,
  ArmchairIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  BellOffIcon,
  BellRingIcon,
  CalendarIcon,
  CalendarClockIcon,
  ChartColumnIcon,
  ChartGanttIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleCheckIcon,
  CircleIcon,
  ClockIcon,
  ContactIcon,
  CopyIcon,
  DownloadIcon,
  Edit3Icon,
  ExternalLinkIcon,
  FlagIcon,
  FolderOpenIcon,
  FunnelXIcon,
  GlobeLockIcon,
  GripVerticalIcon,
  Grid3X3Icon,
  HeadsetIcon,
  InboxIcon,
  InfoIcon,
  LayoutDashboardIcon,
  ListIcon,
  LoaderCircleIcon,
  LockIcon,
  LogInIcon,
  LogOutIcon,
  LucideProps,
  MessageSquareIcon,
  MessagesSquareIcon,
  MonitorIcon,
  MoreHorizontalIcon,
  MoreVerticalIcon,
  PencilIcon,
  PhoneIcon,
  PlusIcon,
  PlusSquareIcon,
  PrinterIcon,
  PuzzleIcon,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SettingsIcon,
  SlidersHorizontalIcon,
  SquareArrowDownIcon,
  SquareArrowUpIcon,
  SquarePenIcon,
  TagIcon,
  TagsIcon,
  TrashIcon,
  TriangleAlertIcon,
  UndoIcon,
  UploadIcon,
  UserIcon,
  UsersIcon,
  WarehouseIcon,
  XIcon,
  ZapIcon,
  ArrowDownUpIcon,
  ArrowRightLeftIcon,
  BarChart3Icon,
  AlertTriangleIcon,
  UserCheckIcon,
  CheckCircleIcon,
  PanelLeftIcon,
  PanelRightIcon,
  PanelRightCloseIcon,
  PanelLeftCloseIcon,
  ClockAlertIcon,
  ClockPlusIcon,
  ClockArrowDownIcon,
  ClockArrowUpIcon,
  ClockFadingIcon,
  RotateCwIcon,
  RotateCcwIcon,
  CarIcon,
  HashIcon,
  FileQuestionIcon,
  MinusIcon,
  ClipboardCheckIcon,
  ClipboardIcon,
  WrenchIcon,
  DollarSignIcon,
  StarIcon,
  BookmarkIcon,
  SquarePlusIcon,
  MapPinCheckInsideIcon,
  CalendarSyncIcon,
  UserPenIcon,
  SquareChevronUpIcon,
  PanelTopCloseIcon,
  PaletteIcon,
  SirenIcon,
  ClipboardListIcon,
  MessageSquareWarningIcon,
  TimerIcon,
  TimerOffIcon,
  TimerResetIcon,
  TagPlusIcon,
  TagXIcon,
} from "lucide-react";
import { FC } from "react";

const IconDefaults: Record<IconNames, FC<LucideProps>> = {
  [IconNames.activityFeed]: (props) => <ChartGanttIcon {...props} />,
  [IconNames.add]: (props) => <PlusSquareIcon {...props} />,
  [IconNames.automation]: (props) => <ZapIcon {...props} />,
  [IconNames.appointment]: (props) => <CalendarClockIcon {...props} />,
  [IconNames.bell]: (props) => <BellRingIcon {...props} />,
  [IconNames.bellOff]: (props) => <BellOffIcon {...props} />,
  [IconNames.calendar]: (props) => <CalendarIcon {...props} />,
  [IconNames.car]: (props) => <CarIcon {...props} />,
  [IconNames.card]: (props) => <AppWindowIcon {...props} />,
  [IconNames.chevronDown]: (props) => <ChevronDownIcon {...props} />,
  [IconNames.chevronUp]: (props) => <ChevronUpIcon {...props} />,
  [IconNames.chevronLeft]: (props) => <ChevronLeftIcon {...props} />,
  [IconNames.chevronRight]: (props) => <ChevronRightIcon {...props} />,
  [IconNames.circle]: (props) => <CircleIcon {...props} />,
  [IconNames.circleCheck]: (props) => <CircleCheckIcon {...props} />,
  [IconNames.check]: (props) => <CheckIcon {...props} />,
  [IconNames.clear]: (props) => <XIcon {...props} />,
  [IconNames.clearFilters]: (props) => <FunnelXIcon {...props} />,
  [IconNames.clock]: (props) => <ClockIcon {...props} />,
  [IconNames.clockDown]: (props) => <ClockArrowDownIcon {...props} />,
  [IconNames.clockUp]: (props) => <ClockArrowUpIcon {...props} />,
  [IconNames.clockFade]: (props) => <ClockFadingIcon {...props} />,
  [IconNames.clockAdd]: (props) => <ClockPlusIcon {...props} />,
  [IconNames.clockWarn]: (props) => <ClockAlertIcon {...props} />,
  [IconNames.clipboard]: (props) => <ClipboardIcon {...props} />,
  [IconNames.clipboardCheck]: (props) => <ClipboardCheckIcon {...props} />,
  [IconNames.container]: (props) => <AppWindowMacIcon {...props} />,
  [IconNames.customerUpdate]: (props) => <ContactIcon {...props} />,
  [IconNames.dashboard]: (props) => <MonitorIcon {...props} />,
  [IconNames.delete]: (props) => <TrashIcon {...props} />,
  [IconNames.dollarSign]: (props) => <DollarSignIcon {...props} />,
  [IconNames.downArrow]: (props) => <ArrowDownIcon {...props} />,
  [IconNames.download]: (props) => <DownloadIcon {...props} />,
  [IconNames.duplicate]: (props) => <CopyIcon {...props} />,
  [IconNames.dueIn]: (props) => <SquareArrowDownIcon {...props} />,
  [IconNames.dueOut]: (props) => <SquareArrowUpIcon {...props} />,
  [IconNames.edit]: (props) => <PencilIcon {...props} />,
  [IconNames.editLine]: (props) => <Edit3Icon {...props} />,
  [IconNames.editSquare]: (props) => <SquarePenIcon {...props} />,
  [IconNames.employees]: (props) => <UsersIcon {...props} />,
  [IconNames.filters]: (props) => <SlidersHorizontalIcon {...props} />,
  [IconNames.featureFlags]: (props) => <FlagIcon {...props} />,
  [IconNames.globalFeatureFlags]: (props) => <GlobeLockIcon {...props} />,
  [IconNames.grid]: (props) => <Grid3X3Icon {...props} />,
  [IconNames.gripVertical]: (props) => <GripVerticalIcon {...props} />,
  [IconNames.inbox]: (props) => <InboxIcon {...props} />,
  [IconNames.info]: (props) => <InfoIcon {...props} />,
  [IconNames.integration]: (props) => <PuzzleIcon {...props} />,
  [IconNames.jobs]: (props) => <WrenchIcon {...props} />,
  [IconNames.layouts]: (props) => <LayoutDashboardIcon {...props} />,
  [IconNames.leftArrow]: (props) => <ArrowLeftIcon {...props} />,
  [IconNames.list]: (props) => <ListIcon {...props} />,
  [IconNames.loader]: (props) => <LoaderCircleIcon {...props} />,
  [IconNames.lock]: (props) => <LockIcon {...props} />,
  [IconNames.login]: (props) => <LogInIcon {...props} />,
  [IconNames.logout]: (props) => <LogOutIcon {...props} />,
  [IconNames.message]: (props) => <MessageSquareIcon {...props} />,
  [IconNames.messages]: (props) => <MessagesSquareIcon {...props} />,
  [IconNames.metrics]: (props) => <ChartColumnIcon {...props} />,
  [IconNames.minimize]: (props) => <MinusIcon {...props} />,
  [IconNames.moreVertical]: (props) => <MoreVerticalIcon {...props} />,
  [IconNames.moreHorizontal]: (props) => <MoreHorizontalIcon {...props} />,
  [IconNames.number]: (props) => <HashIcon {...props} />,
  [IconNames.open]: (props) => <ExternalLinkIcon {...props} />,
  [IconNames.panelLeft]: (props) => <PanelLeftIcon {...props} />,
  [IconNames.panelLeftClose]: (props) => <PanelLeftCloseIcon {...props} />,
  [IconNames.panelRight]: (props) => <PanelRightIcon {...props} />,
  [IconNames.panelRightClose]: (props) => <PanelRightCloseIcon {...props} />,
  [IconNames.phone]: (props) => <PhoneIcon {...props} />,
  [IconNames.print]: (props) => <PrinterIcon {...props} />,
  [IconNames.question]: (props) => <FileQuestionIcon {...props} />,
  [IconNames.rightArrow]: (props) => <ArrowRightIcon {...props} />,
  [IconNames.rotateCw]: (props) => <RotateCwIcon {...props} />,
  [IconNames.rotateCcw]: (props) => <RotateCcwIcon {...props} />,
  [IconNames.save]: (props) => <SaveIcon {...props} />,
  [IconNames.search]: (props) => <SearchIcon {...props} />,
  [IconNames.settings]: (props) => <SettingsIcon {...props} />,
  [IconNames.shop]: (props) => <WarehouseIcon {...props} />,
  [IconNames.sort]: (props) => <ArrowDownUpIcon {...props} />,
  [IconNames.support]: (props) => <HeadsetIcon {...props} />,
  [IconNames.sync]: (props) => <RefreshCwIcon {...props} />,
  [IconNames.tag]: (props) => <TagIcon {...props} />,
  [IconNames.tags]: (props) => <TagsIcon {...props} />,
  [IconNames.undo]: (props) => <UndoIcon {...props} />,
  [IconNames.upArrow]: (props) => <ArrowUpIcon {...props} />,
  [IconNames.upload]: (props) => <UploadIcon {...props} />,
  [IconNames.user]: (props) => <UserIcon {...props} />,
  [IconNames.users]: (props) => <UsersIcon {...props} />,
  [IconNames.waiter]: (props) => <ArmchairIcon {...props} />,
  [IconNames.warning]: (props) => <TriangleAlertIcon {...props} />,
  [IconNames.x]: (props) => <XIcon {...props} />,
  [IconNames.folderOpen]: (props) => <FolderOpenIcon {...props} />,
  [IconNames.plus]: (props) => <PlusIcon {...props} />,
  [IconNames.barChart]: (props) => <BarChart3Icon {...props} />,
  [IconNames.alertTriangle]: (props) => <AlertTriangleIcon {...props} />,
  [IconNames.userCheck]: (props) => <UserCheckIcon {...props} />,
  [IconNames.checkCircle]: (props) => <CheckCircleIcon {...props} />,
  [IconNames.move]: (props) => <ArrowRightLeftIcon {...props} />,
  [IconNames.bidirectional]: (props) => <ArrowRightLeftIcon {...props} />,
  [IconNames.promiseTime]: (props) => <StarIcon {...props} />,
  [IconNames.linkedLabel]: (props) => <BookmarkIcon {...props} />,
  [IconNames.cardCreatedTrigger]: (props) => <SquarePlusIcon {...props} />,
  [IconNames.cardMovedIntoContainer]: (props) => <LogInIcon {...props} />,
  [IconNames.cardMovedOutOfContainer]: (props) => <LogOutIcon {...props} />,
  [IconNames.cardChangesToWaiter]: (props) => <ArmchairIcon {...props} />,
  [IconNames.cardChangesToDropOff]: (props) => (
    <MapPinCheckInsideIcon {...props} />
  ),
  [IconNames.whenPromiseTimeDue]: (props) => <StarIcon {...props} />,
  [IconNames.whenScheduledTimeOccurs]: (props) => (
    <CalendarSyncIcon {...props} />
  ),
  [IconNames.isWaiter]: (props) => <ArmchairIcon {...props} />,
  [IconNames.isDropOff]: (props) => <MapPinCheckInsideIcon {...props} />,
  [IconNames.containerNameIs]: (props) => <LayoutDashboardIcon {...props} />,
  [IconNames.technicianNameIs]: (props) => <UserIcon {...props} />,
  [IconNames.serviceAdvisorNameIs]: (props) => <UserPenIcon {...props} />,
  [IconNames.estimatedLaborGreater]: (props) => <WrenchIcon {...props} />,
  [IconNames.estimatedLaborLess]: (props) => <WrenchIcon {...props} />,
  [IconNames.vehicleMakeIs]: (props) => <CarIcon {...props} />,
  [IconNames.resetAutomated]: (props) => <RotateCcwIcon {...props} />,
  [IconNames.wiggleCard]: (props) => <SquareChevronUpIcon {...props} />,
  [IconNames.wiggleAndSetCardColor]: (props) => (
    <PanelTopCloseIcon {...props} />
  ),
  [IconNames.setCardColor]: (props) => <PaletteIcon {...props} />,
  [IconNames.flashColor]: (props) => <SirenIcon {...props} />,
  [IconNames.changeCardColor]: (props) => <PaletteIcon {...props} />,
  [IconNames.createCustomerUpdate]: (props) => <ContactIcon {...props} />,
  [IconNames.createATask]: (props) => <ClipboardListIcon {...props} />,
  [IconNames.showAToast]: (props) => <MessageSquareWarningIcon {...props} />,
  [IconNames.startATimer]: (props) => <TimerIcon {...props} />,
  [IconNames.stopATimer]: (props) => <TimerOffIcon {...props} />,
  [IconNames.resetATimer]: (props) => <TimerResetIcon {...props} />,
  [IconNames.addTags]: (props) => <TagPlusIcon {...props} />,
  [IconNames.removeTags]: (props) => <TagXIcon {...props} />,
};

export interface IconProps extends LucideProps {
  name: IconNames;
}

export const Icon = ({ name, ...props }: IconProps) => {
  return IconDefaults[name](props);
};
